import { render } from "./count-down.vue?vue&type=template&id=5d5cbd64"
import script from "./count-down.vue?vue&type=script&lang=js"
export * from "./count-down.vue?vue&type=script&lang=js"

import exportComponent from "/builds/x3-web/pc/pc-yunxiao/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__